import AboutIntro from "./AboutIntro";
import AboutRecycle from "./AboutRecycle";
import AboutRepurpose from "./AboutRepurpose";
import AboutResale from "./AboutResale";
import AboutUs from "./AboutUs";
import Box from "./Box";
import Layout from "./Layout";
import PageContent from "./PageContent";
import React from "react";
import TakebackStats from "./TakebackStats";
import WhatHappens from "./WhatHappens";

function AboutPage({ pageData, navItems, globalData }) {
  return (
    <Layout navItems={navItems} globalData={globalData}>
      <PageContent>
        <AboutIntro
          mainHeading={pageData.heading}
          subheading={pageData.introHeading}
          text={pageData.introText}
          imageDesktop={pageData.introImageDesktop}
          imageMobile={pageData.introImageMobile}
        />
        <Box bg="mushroom" pt={["40%", "15.2%", null, null]}>
          <WhatHappens
            heading={pageData.whatHappensHeading}
            text={pageData.whatHappensText}
          />
        </Box>
        <TakebackStats
          resale={pageData.resale}
          reuse={pageData.reuse}
          recycle={pageData.recycle}
          landfill={pageData.landfill}
        />
        <AboutUs callout={pageData.aboutCallout} text={pageData.aboutText} />
        <AboutResale
          image={pageData.resaleMainImageDesktop}
          mobImage={pageData.resaleMainImageMobile}
          callout1={pageData.resaleCallout1}
          text1={pageData.resaleText1}
          callout2={pageData.resaleCallout2}
          text2={pageData.resaleText2}
          sectionId="about-resale"
        />
        <AboutRepurpose
          image={pageData.repurposeMainImageDesktop}
          mobImage={pageData.repurposeMainImageMobile}
          callout={pageData.repurposeCallout}
          text={pageData.repurposeText}
          sectionId="about-repurpose"
        />
        <AboutRecycle
          image={pageData.recycleMainImageDesktop}
          mobImage={pageData.recycleMainImageMobile}
          subheading={pageData.recycleSubheading}
          callout1={pageData.recycleCallout1}
          text1={pageData.recycleText1}
          image1={pageData.recycleImage1}
          image2={pageData.recycleImage2}
          callout2={pageData.recycleCallout2}
          text2={pageData.recycleText2}
          sectionId="about-recycle"
        />
      </PageContent>
    </Layout>
  );
}

export default AboutPage;
